const UserStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export default UserStatus;
